export default "__VITE_ASSET__e62e5204__"